// src/pages/Admin/Dashboard/tabs/customers/EditCustomer.jsx

import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import configrations from "../../../../../config/configrations";
// import { getUserDetailsById, updateUser } from "../../../../../services/api";
import { adminApi } from "../../../../../services/index";

export default function EditCustomer() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
  });

  const [currentImage, setCurrentImage] = useState("");  // existing image from DB
  const [newImage, setNewImage] = useState(null);        // selected image file
  const [preview, setPreview] = useState("");            // preview URL

  const [loading, setLoading] = useState(true);

  // ===== Fetch user details =====
  const fetchUser = async () => {
    try {
      const { data } = await adminApi.getUserDetailsById(id);

      setForm({
        name: data.data.name,
        email: data.data.email,
        phone: data.data.phone,
        address: data.data.address,
      });

      setCurrentImage(data.data.image); // load existing profile image
      console.log('data :', data);

      setLoading(false);
    } catch (error) {
      console.log("Error:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);

  // ===== Handle Input Fields =====
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // ===== Handle Image Upload =====
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setNewImage(file);
    setPreview(URL.createObjectURL(file)); // preview selected image
  };

  // ===== Submit FormData =====
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // const token = localStorage.getItem("token");

      // FormData for sending file + text
      const formData = new FormData();
      formData.append("name", form.name);
      formData.append("email", form.email);
      formData.append("phone", form.phone);
      formData.append("address", form.address);

      if (newImage) formData.append("image", newImage);

      // await axios.put(
      //   `${configurations.backendBaseUrl}/api/users/${id}`,
      //   formData,
      //   {
      //     headers: {
      //       Authorization: `Bearer ${token}`,
      //       "Content-Type": "multipart/form-data",
      //     },
      //   }
      // );

      await adminApi.updateUser(id, formData);
      navigate("/admin-dashboard/customers"); // redirect on success
    } catch (error) {
      alert(error.response?.data?.message || "Update failed");
    }
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div className="container mt-4">
      <h2>Edit Customer</h2>

      <form onSubmit={handleSubmit} style={{ maxWidth: "400px" }}>
        
        {/* Image Preview Section */}
        <div className="mb-3">
          <label className="form-label">Profile Image</label>
          <div>
            <img
              src={
                preview
                  ? preview
                  : currentImage
                  // ? `${configurations.backendBaseUrl}${currentImage}`
                  ? `${configrations.backendBaseDomain}${currentImage}`
                  : "https://via.placeholder.com/120"
              }
              alt="profile"
              style={{
                width: "120px",
                height: "120px",
                objectFit: "cover",
                borderRadius: "8px",
                marginBottom: "10px",
              }}
            />
          </div>

          <input
            type="file"
            accept="image/*"
            className="form-control"
            onChange={handleImageChange}
          />
        </div>

        {/* Name */}
        <label>Name</label>
        <input
          className="form-control mb-2"
          name="name"
          value={form.name}
          onChange={handleChange}
          required
        />

        {/* Email */}
        <label>Email</label>
        <input
          className="form-control mb-2"
          name="email"
          type="email"
          value={form.email}
          onChange={handleChange}
          required
        />

        {/* Phone */}
        <label>Phone</label>
        <input
          className="form-control mb-2"
          name="phone"
          value={form.phone}
          onChange={handleChange}
          required
        />

        {/* Address */}
        <label>Address</label>
        <input
          className="form-control mb-2"
          name="address"
          value={form.address}
          onChange={handleChange}
        />

        {/* Submit */}
        <button className="btn btn-primary mt-2" type="submit">
          Save Changes
        </button>
      </form>
    </div>
  );
}
